module.exports = __webpack_public_path__ + "af.0dfb903b8954bc9c6bae.svg";


//////////////////
// WEBPACK FOOTER
// E:/proj/news12/zb-n12/scadmin/client/src/assets/fonts/flag-icon-css/flags/1x1/af.svg
// module id = ../../../../../src/assets/fonts/flag-icon-css/flags/1x1/af.svg
// module chunks = styles